"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grid = Grid;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _mui_spacing = _interopRequireDefault(require("../../birch/layouts/mui_spacing"));
var _birch_identification = require("../../birch/utils/birch_identification");
var _excluded = ["sx"],
  _excluded2 = ["container", "sx", "justifyContent", "justify"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// This value is multiplied by 8px and results in a 24px gutter between elements
// The 'spacing' value should only be passed to container elements
var DEFAULT_SPACING = 3;

// Dump the parsed rules into the styled component
// @ts-expect-error - TS2339 - Property 'sx' does not exist on type '{ alignContent?: GridContentAlignment | undefined; alignItems?: GridItemsAlignment | undefined; children?: ReactNode; ... 12 more ...; zeroMinWidth?: boolean | undefined; } & CommonProps<...> & Pick<...> & ThemeProps<...>'.
var StyledMuiGrid = (0, _styledComponents["default"])(_Grid["default"]).attrs(function (_ref) {
  var sx = _ref.sx,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return {
    // @ts-expect-error - TS2339 - Property 'grow' does not exist on type '{ alignContent?: GridContentAlignment | undefined; alignItems?: GridItemsAlignment | undefined; children?: ReactNode; container?: boolean | undefined; ... 269 more ...; theme: DefaultTheme; }'.
    'flex-grow': props.grow,
    sx: sx
  };
}).withConfig({
  displayName: "grid__StyledMuiGrid"
})(["", " ", " flex-grow:", ""], function (_ref2) {
  var sx = _ref2.sx;
  return sx;
}, /* @ts-expect-error Flow -> TS migration */'', function (_ref3) {
  var grow = _ref3.grow;
  return grow ? grow : '';
});
function Grid(_ref4) {
  var container = _ref4.container,
    sx = _ref4.sx,
    justifyContent = _ref4.justifyContent,
    justify = _ref4.justify,
    rest = (0, _objectWithoutProperties2["default"])(_ref4, _excluded2);
  var spacingSx = (0, _mui_spacing["default"])(sx);
  return container ? /*#__PURE__*/React.createElement(StyledMuiGrid, (0, _extends2["default"])({
    spacing: DEFAULT_SPACING,
    container: container,
    justifyContent: justifyContent || justify
  }, rest, {
    sx: spacingSx
  }, (0, _birch_identification.getDataBirchProps)(rest, 'Grid'))) : /*#__PURE__*/React.createElement(StyledMuiGrid, (0, _extends2["default"])({
    container: container,
    justifyContent: justifyContent || justify
  }, rest, {
    sx: spacingSx
  }, (0, _birch_identification.getDataBirchProps)(rest, 'Grid')));
}